import { SummaryStatementFormItem } from "@/types/financials/SummaryStatement";

export const defaultSummaryStatementFormItem =
  (): SummaryStatementFormItem => ({
    startDate: "",
    endDate: "",
    bankAccountId: 0,
    contactType: -1,
    specialContactId: 0,
    statmentCount: 0,
    productId: 0,
    debitAmount: 0,
    statementNotes: "",
    statementsFilings: 0,
    statementsPostings: 0,
    statementsEmails: 0,
    enableButRun: false,
    enableButPrintForFiling: false,
    enableButPrintForPosting: false,
    enableButEmail: false,
    enableGrpCharge: true,
    enableGrpContacts: true,
  });

export const FinancialDefaults = {
  defaultSummaryStatementFormItem: defaultSummaryStatementFormItem,
};
